import { api } from '../../../helpers'
import { appConstants } from '../../../constants'

export const fetchLatest = (page, limit) => {
  return dispatch => {
    dispatch(loadLatestRequest())
    api.get('web/article/filterBy/lastest?page=1&limit=14')
      .then((res) => {
        const { data: latest, success, message } = res.data
        if (success === 'true') {
          dispatch(loadLatestSuccess(latest))
        } else {
          dispatch(loadLatestFailed(message))
        }
      })
      .catch((message) => loadLatestFailed(message))
  }
}

const loadLatestRequest = () => ({
  type: appConstants.GET_LATEST_REQUEST
})

const loadLatestSuccess = (latest) => ({
  type: appConstants.GET_LATEST_SUCCESS,
  payload: { latest }
})

const loadLatestFailed = (message) => ({
  type: appConstants.GET_LATEST_ERROR,
  payload: { message }
})
